import { AxiosError } from 'axios';
import { ApiException } from '../generated/api-client';

function messageFromUnknown(value: unknown): string | null {
  if (value == null) {
    return null;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
  }
  if (Array.isArray(value)) {
    const parts = value.map(messageFromUnknown).filter((part): part is string => !!part);
    return parts.length ? parts.join(', ') : null;
  }
  if (typeof value === 'object') {
    const obj = value as { message?: unknown; msg?: unknown; detail?: unknown };
    return messageFromUnknown(obj.message) || messageFromUnknown(obj.msg) || messageFromUnknown(obj.detail);
  }
  return null;
}

function detailFromPayload(data: unknown): string | null {
  if (data == null) {
    return null;
  }
  if (typeof data === 'string') {
    try {
      return detailFromPayload(JSON.parse(data));
    } catch {
      return data;
    }
  }
  return messageFromUnknown(data);
}

/** Messaggio utente da risposta FastAPI `{ detail: string | string[] }` o fallback. */
export function getAxiosErrorDetail(error: unknown, fallback: string): string {
  if (error instanceof AxiosError && error.response?.data != null) {
    const message = detailFromPayload(error.response.data);
    if (message) {
      return message;
    }
  }
  if (ApiException.isApiException(error)) {
    const message = detailFromPayload(error.response);
    if (message) {
      return message;
    }
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
